export const MANAGE_REGISTRY_ITEM_PARAM = 'registryItemId';

export const buildManageRegistryItemPath = (eventHandle: string, registryItemId: string) =>
  `/${eventHandle}/edit/registry/manage?${MANAGE_REGISTRY_ITEM_PARAM}=${encodeURIComponent(registryItemId)}`;
